export default function Card({
  children,
  className = '',
  hover = false,
  padding = 'md',
  ...props
}) {
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  };

  return (
    <div
      className={`
        bg-white dark:bg-gray-800
        rounded-xl
        border border-gray-100 dark:border-gray-700
        ${hover ? 'hover:shadow-lg hover:-translate-y-1 transition-all duration-300 touch-card' : 'shadow-sm'}
        ${paddingClasses[padding]}
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  );
}
